export const ds_EventsListingBlock_Entry = `
    fragment ds_EventsListingBlock_Entry on ds_EventsListingBlock_Entry {
        id
        canonicalUid
        eventsListing_TopSpacing
        eventsListing_FullWidthBackground
        eventsListing_ContainerWidth
        eventsListing_ColorTheme
        eventsListing_ColorPalette

        eventsListing_Heading
        eventsListing_BodyText

        eventsListing_Category {
            id
            title
        }
    }
`